<template>
  <div class="wrap">
    <el-row type="flex" justify="center">
      <el-col :span="20">
        <div class="page-nav">
          <i class="el-icon-arrow-left" @click="toBack"></i>
          <span>选择创建方式</span>
        </div>
        <h3>空白创建</h3>
        <div class="flex">
          <div class="empty-create" @click="emptyCreate">
            <!-- <span class="left"><i class="icon-kongbaichuangjian"></i></span> -->
            <img class="w-9 h-9" src="@/assets/img/scene/empty.png"/>
            <div class="right ml-3">
              <p>空白创建</p>
              <p>从0搭建问卷</p>
            </div>
          </div>
          <div class="empty-create ml-4" @click="openManualInput">
            <img class="w-9 h-9" src="@/assets/img/scene/manual-input.png"/>
            <div class="right ml-3">
              <p>人工录入问卷</p>
              <p>开通付费年会员，享免费录入服务</p>
            </div>
          </div>
        </div>
        <h3 v-custom:create-survey="'out_D18'">从模版创建</h3>
      </el-col>
    </el-row>
    <Library :isChoicest="false" v-custom:create-survey="'out_D18'"/>
    <ManualInputDialog :visible.sync="visible"/>
  </div>
</template>

<script>
import Library from '@/views/home/template/Template'
import wj_list from './components/wj_list'
import ManualInputDialog from '@/question/components/popup/ManualInputDialog'

  export default {
    name:'createSurvey',
    components:{Library, ManualInputDialog},
    mixins:[wj_list],
    data() {
      return {
        visible: false
      }
    },
    methods:{
      emptyCreate(){
        this.debounceCreate(this.onClickCreate);
      },
      toBack(){
        this.$router.back();
      },
      openManualInput() {
        this.visible = true;
      }
    }
  }
</script>

<style lang="scss" scoped>
.wrap{
  @apply bg-bg-common-color h-full overflow-auto;
  @mixin title{
    color: rgba($color: #000000, $alpha: 0.85);
    margin: 24px auto 12px 0;
    @apply font-normal text-medium-x;
  }
  h3{
    @include title;
  }
  .page-nav{
    @apply relative mt-6;
    .el-icon-arrow-left{
      background: #a5b4cc;
      border-radius: 50%;
      @apply absolute inline-block w-6 h-6 left-0 top-0 cursor-pointer text-white text-center leading-24 text-20 font-semibold;
    }
    span{
      margin: 0 auto;
      width: 132px;
      font-size: 22px;
      @apply block font-normal text-black;
    }
  }
  .empty-create{
    width: 288px;
    height: 110px;
    @apply flex bg-white rounded-small justify-center cursor-pointer items-center;
    &:hover{
      // box-shadow: 0 6px 10px 0 rgba(0,0,0,0.08);
      border: 1px solid;
      @apply border-theme box-border;
    }
    .left{
      width: 36px;
      height: 36px;
      font-size: 36px;
      margin-right: 14px;
      line-height: 36px;
      @apply text-theme-text-gray;
    }
    .right{
      // @apply mt-8;
      p:first-child{
        padding-bottom: 1px;
        @apply font-normal text-theme-black-850 text-medium-x leading-22;
      }
      p:last-child{
        padding-top: 1px;
        @apply font-normal text-theme-black-450 text-small leading-22;
      }
    }
  }
  ::v-deep .wrapper{
    // background: #F2F5FA !important;
    @apply bg-bg-common-color;
  }
  ::v-deep .search-wrap{
    height: auto !important;
    line-height: initial;
    // @apply mb-6;
  }
  ::v-deep .el-input-group{
    .el-input__inner{
      border-color: #2775E8 !important;
    }
  }
  ::v-deep .cate-block{
    background: #fff !important;
  }
  ::v-deep .order-block{
    background: #fff !important;
  }
  ::v-deep .el-pagination{
    .el-input__inner{
      @apply bg-white;
    }
    .btn-prev,.el-pager li,.btn-next{
      @apply bg-bg-common-color;
    }
    // .el-pager li{
    //   background: #F2F5FA !important;
    // }
  }
}
</style>